import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Atualiza o estado para que a próxima renderização mostre a UI de fallback.
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // Você também pode registrar o erro em um serviço de relatórios de erros
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({ errorInfo: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // Você pode renderizar qualquer UI de fallback personalizada
      return (
        <div className="p-4 text-red-600 bg-red-100 border border-red-400 rounded-lg">
          <h2 className="text-lg font-bold mb-2">
            Ocorreu um erro inesperado.
          </h2>
          <p className="mb-2">
            Por favor, tente novamente mais tarde ou entre em contacto com o
            suporte.
          </p>
          <details className="text-sm">
            <summary>Detalhes do Erro</summary>
            <pre className="whitespace-pre-wrap break-words text-xs mt-2">
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
